import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home'
import Location from '@/pages/Location'
import Type from '@/pages/Type'
import Brochure from '@/pages/Brochure'
import Gardens from '@/pages/Gardens'
import Aerial from '@/pages/Aerial'
import Calculator from '@/pages/Calculator'
import IndoorVr from '@/pages/IndoorVr'
import Shengming from '@/pages/Shengming'
import test from '@/pages/test'
import Plan from '@/pages/Plan.vue'
import Building from '@/pages/Building.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/Home',
      name: 'Home',
      component: Home
    },
    {
      path: '/Building',
      name: 'Building',
      component: Building},
    {
      path: '/plan',
      name: 'plan',
      component: Plan
    },
    {
      path: '/Location',
      name: 'Location',
      component: Location,
      meta:{
        navshow:false
      }
    },
    {
      path: '/Type',
      name: 'Type',
      component: Type
    },
    {
      path: '/Brochure',
      name: 'Brochure',
      component: Brochure
    },
    {
      path: '/Aerial',
      name: 'Aerial',
      component: Aerial
    },
   
    {
      path: '/Gardens',
      name: 'Gardens',
      component: Gardens,
      // meta:{
      //   btshow:true
      // }
    },
    {
      path: '/Calculator',
      name: 'Calculator',
      component:Calculator 
    },
     {
      path: '/IndoorVr',
      name: 'IndoorVr',
      component:IndoorVr 
    },
    {
      path: '/Shengming',
      name: 'Shengming',
      component:Shengming 
    },
    {
      path: '/test',
      name: 'test',
      component:test 
    }
   
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js